import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  cleanUpObject,
  createAnalyticsItemsList,
  findCategoryById,
  getMediaPath,
} from "app/functions";
import { AnalyticsParamValues, getRecommendationsPromotionsTypeLogValue } from "constants/analytics";
import * as routes from "constants/routes";
import SliderHeader from "../slider-header";
import SliderContent from "../slider-content";
import PromotionSlide from "../promotion-slide";
import Benefit from "../../../shared/benefit/benefit";
import "./index.scss";
import Analytics from "app/analytics";

const BenefitsSlider = ({
  data,
  creativeSlot,
  promotionName,
}) => {
  const history = useHistory();

  const categories = useSelector(
    (store) => cleanUpObject(store.config.categoriesArr).Data
  );

  const [contentItems, setContentItems] = useState([]);

  const sliderId = data["id"];
  const sliderTitle = data["title"];
  const sliderIconPath = getMediaPath(data["icon_img"]);
  const sliderShowMoreButton = data["btnText"];
  const sliderItems = data["benefits"];
  const isRecommendationsSlider = data?.hideMoreDealsButton;
  const sliderAnalyticsType = isRecommendationsSlider
    ? AnalyticsParamValues.RECOMMENDATIONS_BENEFITS_SLIDER
    : AnalyticsParamValues.NORMAL_BENEFITS_SLIDER;
  const recommendationsPromotionsType = isRecommendationsSlider
    ? getRecommendationsPromotionsTypeLogValue(data?.recommendationsPromotionsType)
    : undefined;
  const sliderAnalyticsSource = AnalyticsParamValues.HOMEPAGE_SLIDER_SOURCE;

  const mainCategoryData = findCategoryById(categories, data?.["id"]) || null;

  const mainCategoryLink = (() => {
    if (mainCategoryData) {
      return `${routes.category}/${mainCategoryData.id}/${mainCategoryData.url_name}`;
    } else {
      return routes.benefits;
    }
  })();

  const handleBenefitClick = (item, index) => {
    Analytics.logSelectPromotion(
      createAnalyticsItemsList([item], {item_list_name: promotionName, index: index}),
      creativeSlot,
      promotionName,
      recommendationsPromotionsType
    );
  };

  useEffect(() => {
    if (!sliderItems?.length) return;

    const benefitsForLog = createAnalyticsItemsList(sliderItems, {item_list_name: promotionName});
    if (!benefitsForLog.length) return;

    Analytics.logViewMainSliderHomePage(
      benefitsForLog,
      creativeSlot,
      promotionName,
      recommendationsPromotionsType
    );
  }, [sliderItems, creativeSlot, promotionName, recommendationsPromotionsType, data]);

  const openLink = () => {
    const link = data.link;
    if (link?.type === "external" && link?.route) {
      if (link.route.startsWith(window.location.origin)) {
        history.push(link.route.replace(window.location.origin, ""));
      } else {
        window.open(link.route);
      }
    } else {
      history.push(mainCategoryLink);
    }
  };

  const getContentItems = () =>
    sliderItems.map((benefitData, index) => (
      <Benefit
        data={benefitData}
        analyticsSource={sliderAnalyticsSource}
        onClick={(benefitData) => handleBenefitClick(benefitData, index)}
      />
    ));

  useEffect(() => {
    setContentItems(getContentItems);
  }, [data]);

  return (
    <div className="homepage-benefits-slider">
      <SliderHeader
        id={sliderId}
        title={sliderTitle}
        iconPath={sliderIconPath}
        onTitleClick={openLink}
        showMoreButton={sliderShowMoreButton}
        onShowMoreButtonClick={openLink}
        tabsList={[]}
        buttonsList={[]}
        analyticsType={sliderAnalyticsType}
        hideMoreDealsButton={data?.hideMoreDealsButton}
      />

      <SliderContent
        itemsList={contentItems}
        creativeSlot={creativeSlot}
        promotionSlide={data?.hideMoreDealsButton ? null : (
          <PromotionSlide
            link={mainCategoryLink}
              sliderId={sliderId}
              sliderTitle={sliderTitle}
              sliderAnalyticsType={sliderAnalyticsType}
            />
          )
        }
      />
    </div>
  );
};

export default BenefitsSlider;
